import React, { Component } from 'react';
import './PersonRegist.css'
import Api from '../../api/wxapi';
import intl from 'react-intl-universal';
import Select from 'react-select';



//常见问题
export default class QuestionList extends Component {
  constructor(props) {
    super();
    this.state = {
        storename:'',
        questions:[]
     
    };
  
  }
  
  componentDidMount(){
    document.title = '常见问题'
    this.getdata();
  }
  render() {

    
    return (
      <div  className='flex-column-container' style={{paddingLeft:12,paddingRight:12,flex:1,}}>
    
         <div className='flex-column-container' style={{flex:1,marginTop:'20px',backgroundColor:'#fff'}}>
              <p style={{marginTop:'10px'}}>设备相关</p>  
              <p style={{width:'100%',backgroundColor:'#F4F4F4',height:'1px',marginTop:'10px',marginBottom:'10px'}}></p>
         
           <div className='flex-column-container' style={{paddingLeft:10,paddingRight:10}}  >
            {this.state.questions.map((item,index)=>{
              return(
               <div  className='flex-column-container'   key={index}  onClick={()=> this.gotoDetail(item)}> 
                <div className='flex-row-container' style={{justifyContent:"space-between"}}> 
                <div className='flex-row-container'> 
                <p>{index+1}.</p>
                <p>{item.question}</p>
                </div>
                <img src={require('../../assets/right.png')}></img>
              
                </div> 
                <p style={{width:'100%',backgroundColor:'#F4F4F4',height:'1px',marginTop:'10px',marginBottom:'10px'}}></p> 
                </div>     )

            })}  
            </div>     
           
           </div>      
        
      </div>
    )
  }
   
  gotoDetail(item){
     
   var path={
    pathname:'/person/QuestionDetail',
    query:item,
  
   }

    this.props.history.push(path)
  }

  getdata(){
   Api.getQuestionList().then(res=>{
     if(res.data.code==0){
       this.setState({questions:res.data.data.questions})
     }
   })

  }


  
}



// WEBPACK FOOTER //
// ./src/views/person/QuestionList.js